module.exports = __webpack_public_path__ + "img/fp.10a25e11.jpeg";